var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-conteudo"},[_c(_setup.CartaoDePedidoDeCompra,{attrs:{"dado":_vm.pedidoDeCompra}}),_c(_setup.JustificativaCartao,{attrs:{"justificativa":_vm.justificativa,"controlesDesativoados":_vm.controlesDesativados},on:{"update:justificativa":_setup.alteraJustificativa}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }